<template>
  <div class="no-such-user">
    <div class="centered" @click="goHome">
      <p class="warning">Account does not exist</p>
      <p><span class="button">Go Home</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoSuchUser",
  data() {
    return {};
  },
  mounted() {
    var msg = `⚠️ NO SUCH USER (${this.$store.getters.getNameAndNumber}) 🤣`;
    this.sendSuperuserNotification(msg);
    this.$store
      .dispatch("logout")
      .catch((err) => console.warn("logout error", err));
  },
  methods: {
    //
  },
};
</script>

<style scoped>
.no-such-user {
  background-color: #fac002;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.warning {
  color: red;
  font-size: 1.2em;
  font-weight: 500;
  margin-bottom: 20px;
}
</style>